import { Label, makeStyles, Spinner, tokens } from '@fluentui/react-components';
import { AddCircle32Filled } from '@fluentui/react-icons';
import { useRef, useState } from 'react';
import BoxArt from './BoxArt';

interface ImageSelectorProps {
	imageUrl?: string;
	isLoading?: boolean;
	saveImage?: (imgData: FormData) => void;
}

export default function ImageSelector(props: ImageSelectorProps) {
	const styles = useStyles();
	const [error, setError] = useState(false);

	const hiddenFileInput = useRef<HTMLInputElement>(null);
	const boxArtOnChange = () => {
		if (props.saveImage && hiddenFileInput.current?.files) {
			const image: Blob = hiddenFileInput.current.files[0];
			const formData = new FormData();
			formData.append('boxArtBlob', image);
			props.saveImage(formData);
		} else {
			setError(true);
		}
	};

	return (
		<div className={styles.boxArtContainer}>
			{error && (
				<span style={{ color: 'red', position: 'absolute' }}>
					Could not upload the image
				</span>
			)}
			{props.imageUrl ? (
				<BoxArt
					imageSrc={props.imageUrl}
					altText='Box Art'
					containerOptions={{ width: '100%', height: '200px' }}
				/>
			) : (
				<>
					{props.isLoading ? (
						<Spinner
							size='large'
							className={styles.addBoxArtBtn}
						/>
					) : (
						<>
							<Label
								htmlFor='boxArtFileInput'
								className={styles.addBoxArtBtn}
								title='Add an Image'
							>
								<AddCircle32Filled />
							</Label>
							<input
								id='boxArtFileInput'
								type='file'
								style={{ display: 'none' }}
								onChange={boxArtOnChange}
								ref={hiddenFileInput}
							/>
						</>
					)}
				</>
			)}
		</div>
	);
}

const useStyles = makeStyles({
	root: {},
	boxArtContainer: {
		width: '100%',
		height: '200px',
		display: 'flex',
		overflow: 'hidden',
		border: `1px dotted ${tokens.colorBrandBackground}`
	},
	addBoxArtBtn: {
		color: tokens.colorBrandBackground,
		margin: 'auto',
		':hover': {
			color: tokens.colorBrandBackground2Hover,
			cursor: 'pointer'
		}
	}
});
